// /es/* and /pt/* pages (config/localeHubs.ts). Data comes from
// utils/localeHubProps.ts; it is a separate module so Next can drop it (and
// mongoose with it) from the browser bundle.
import HeadTermHub from "@/components/hub/HeadTermHub";
import { LOCALE_HUBS } from "@/config/localeHubs";
import type { Locale } from "@jammable/ui-core/src/i18n";

export interface LocaleHubProps {
  locale: Exclude<Locale, "en">;
  slug: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialModels: any[];
}

export default function LocaleHubPage({
  locale,
  slug,
  initialModels,
}: LocaleHubProps) {
  return (
    <HeadTermHub
      config={LOCALE_HUBS[locale][slug]}
      initialModels={initialModels}
    />
  );
}
